var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubAccountEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 300,
    viewBox: "0 0 360 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.627 299.852C250.115 299.852 316.989 232.978 316.989 150.195C316.989 67.413 250.115 0.539062 167.627 0.539062C85.1396 0.539062 18.2656 67.413 18.2656 150.195C18.2656 232.978 85.1396 299.852 167.627 299.852Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.076 88.6239C340.746 88.6239 346.154 83.2162 346.154 76.5454C346.154 69.8745 340.746 64.4668 334.076 64.4668C327.405 64.4668 321.997 69.8745 321.997 76.5454C321.997 83.2162 327.405 88.6239 334.076 88.6239Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.751 41.1929C356.306 41.1929 360 37.4998 360 32.9441C360 28.3884 356.306 24.6953 351.751 24.6953C347.195 24.6953 343.502 28.3884 343.502 32.9441C343.502 37.4998 347.195 41.1929 351.751 41.1929Z",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24877 97.1675C12.8044 97.1675 16.4975 93.4744 16.4975 88.9187C16.4975 84.363 12.8044 80.6699 8.24877 80.6699C3.6931 80.6699 0 84.363 0 88.9187C0 93.4744 3.6931 97.1675 8.24877 97.1675Z",
    fill: "#E4DAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5682 276.578C32.0287 276.578 38.8873 269.719 38.8873 261.259C38.8873 252.798 32.0287 245.939 23.5682 245.939C15.1076 245.939 8.24902 252.798 8.24902 261.259C8.24902 269.719 15.1076 276.578 23.5682 276.578Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2413_1244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.399 244.672H49.4448C35.0279 244.672 23.5684 233.213 23.5684 218.796V82.3901C23.5684 67.9732 35.0279 56.5137 49.4448 56.5137H286.399C300.816 56.5137 312.275 67.9732 312.275 82.3901V218.796C312.275 233.213 300.816 244.672 286.399 244.672Z",
    fill: "#F3F1FC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7619 202.161H59.0562C55.7292 202.161 53.1416 199.574 53.1416 196.247C53.1416 192.92 55.7292 190.332 59.0562 190.332H96.7619C100.089 190.332 102.676 192.92 102.676 196.247C102.676 199.574 100.089 202.161 96.7619 202.161Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.756 202.161H120.05C116.723 202.161 114.136 199.574 114.136 196.247C114.136 192.92 116.723 190.332 120.05 190.332H157.756C161.083 190.332 163.671 192.92 163.671 196.247C163.671 199.574 161.083 202.161 157.756 202.161Z",
    fill: "#15112D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.75 202.161H181.044C177.718 202.161 175.13 199.574 175.13 196.247C175.13 192.92 177.718 190.332 181.044 190.332H218.75C222.077 190.332 224.665 192.92 224.665 196.247C224.665 199.574 222.077 202.161 218.75 202.161Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.745 202.161H242.04C238.713 202.161 236.125 199.574 236.125 196.247C236.125 192.92 238.713 190.332 242.04 190.332H279.745C283.072 190.332 285.66 192.92 285.66 196.247C285.66 199.574 283.072 202.161 279.745 202.161Z",
    fill: "#D5DDEA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M266.067 131.186C278.317 131.186 288.247 121.256 288.247 109.006C288.247 96.7564 278.317 86.8262 266.067 86.8262C253.818 86.8262 243.888 96.7564 243.888 109.006C243.888 121.256 253.818 131.186 266.067 131.186Z",
    fill: "#989FB0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M236.864 131.186C249.114 131.186 259.044 121.256 259.044 109.006C259.044 96.7564 249.114 86.8262 236.864 86.8262C224.615 86.8262 214.685 96.7564 214.685 109.006C214.685 121.256 224.615 131.186 236.864 131.186Z",
    fill: "#7647EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.089 138.21H58.6866C55.7292 138.21 53.1416 135.622 53.1416 132.665V106.049C53.1416 103.092 55.7292 100.504 58.6866 100.504H99.7192C102.676 100.504 105.264 103.092 105.264 106.049V132.665C105.634 135.622 103.046 138.21 100.089 138.21Z",
    fill: "#15112D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2413_1244",
    x: 1.56836,
    y: 45.5137,
    width: 332.707,
    height: 232.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2413_1244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2413_1244",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAccountEmptyState);
export default __webpack_public_path__ + "static/media/subAccountEmptyState.fb2c9a62dd404368d9cb0d60b172081f.svg";
export { ForwardRef as ReactComponent };